import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';
import minecraftUrls from "src/configs/mine_craft/minecraftUrls";
import { BannedIpInterface } from 'src/store/mine_craft/bannedIpsSlice';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.bannedIpPath(value.id)
  };
}

export const bannedIpsEntity = new schema.Entity('bannedIps', {}, { processStrategy });
export const bannedIpEntity = new schema.Entity('bannedIp', {}, { processStrategy });

const fetchBannedIpsCollection = async (url: string, params: object = {}) => {
  const response = await mineCraftApi.get(url, { params })
  const normalized = normalize<any, { bannedIps: { [key: string]: BannedIpInterface }; }>(
    response.data.banned_ips, [bannedIpsEntity]
  );

  return {
    bannedIps: normalized.entities?.bannedIps || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { bannedIp: BannedIpInterface; }>(
    response.data.banned_ip, bannedIpEntity
  );
  return normalized.entities;
}

export const fetchBannedIps = createAsyncThunk(
  'bannedIps/fetchBannedIps',
  async (params: object = {}) => fetchBannedIpsCollection('/onesky/banned_ips', params)
);

export const fetchBannedIp = createAsyncThunk(
  'bannedIps/fetchBannedIp',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/banned_ips/${id}`);
    return normalizeInstance(response);
  }
);

export const createBannedIp = createAsyncThunk(
  'bannedIps/createBannedIp',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/banned_ips`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateBannedIp = createAsyncThunk(
  'bannedIps/updateBannedIp',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/banned_ips/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyBannedIp = createAsyncThunk(
  'bannedIps/destroyBannedIp',
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/banned_ips/${id}`);
    return { id };
  }
);
